// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3JS2y","inputWrap":"Table_inputWrap__20chz","col":"Table_col__3yf-6","bmiTooltip":"Table_bmiTooltip__3Ojw6"};